export function colorToken(value) {
  if (value === 'transparent') {
    return value;
  }
  return `var(--${value})`;
}